import { lazy } from 'react';

const RETRY_MARKER = 'lazy-retry-attempted';

const isChunkLoadError = (error) => {
  const message = String(error?.message || '');
  const name = String(error?.name || '');
  return name.includes('ChunkLoadError') || message.includes('Loading chunk');
};

export default function lazyWithRetry(importFn) {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (error) {
      if (isChunkLoadError(error) && typeof window !== 'undefined') {
        const hasRetried = window.sessionStorage.getItem(RETRY_MARKER) === 'true';
        if (!hasRetried) {
          window.sessionStorage.setItem(RETRY_MARKER, 'true');
          window.location.reload();
          return new Promise(() => {});
        }
      }

      throw error;
    }
  });
}

